module.exports = __webpack_public_path__ + "img/creditos.3c25d6c3.svg";